import { DateTime } from 'luxon';
import { HendelseloggFilterDto } from 'services/hendelsekontroll/hendelselogg/dto';

import { InvalidFilterProps } from './interface';

export const initialFilterValues: HendelseloggFilterDto = Object.freeze({
  deltakerId: '',
  brukerId: '',
  hendelsestyper: [],
  fraOgMedDato: null,
  tilOgMedDato: null,
  ekskluderHarKvittering: true,
  inkluderSystembrukere: false,
});

export const initialFilterValuesInvalid: InvalidFilterProps = Object.freeze({
  hendelsestyper: false,
  fraOgMedDato: false,
  tilOgMedDato: false,
});

export const createNewErrorState = (formValues?: HendelseloggFilterDto) => {
  const formStateInvalidCopy = { ...initialFilterValuesInvalid };

  const henvendelsestyperLength = formValues?.hendelsestyper?.length;
  if (henvendelsestyperLength !== undefined && henvendelsestyperLength < 1)
    formStateInvalidCopy.hendelsestyper = true;

  const { fraOgMedDato, tilOgMedDato } = formValues || {};

  if (!fraOgMedDato || !DateTime.fromISO(fraOgMedDato).isValid) {
    formStateInvalidCopy.fraOgMedDato = true;
  }

  if (
    (tilOgMedDato && !DateTime.fromISO(tilOgMedDato).isValid) ||
    (fraOgMedDato && tilOgMedDato && fraOgMedDato > tilOgMedDato)
  ) {
    formStateInvalidCopy.tilOgMedDato = true;
  }
  return formStateInvalidCopy;
};

export const parseHendelseIds = (id: string) => {
  return id.split(',').map((id) => Number(id));
};
export const joinHendelseIds = (ids: number[]) => {
  return ids.join();
};
